export function getScrollbarWidth(): number {
    return window.innerWidth - document.documentElement.clientWidth;
}
